<template>
  <div
    class="container-top mt-5"
    :class="{ 'container-slim': lgAndUp || xlAndUp }"
  >
    <div class="row">
      <div class="col-md-12 parent-desc first">
        <div class="text-head h2 font-weight-bold py-0 my-0 text-black">
          Opening Balances
        </div>
        <BackRoute />
      </div>
    </div>
    <div class="row mt-3" v-if="gettingSelectedTrsn">
      <div class="col-md-12 text-center">
        <el-icon class="is-loading">
          <Loading />
        </el-icon>
      </div>
    </div>
    <div class="container">
      <div class="row mt-3">
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-6">
              <label class="label-text" for=""
                >Date <span class="text-danger">*</span></label
              >
              <el-date-picker
                v-model="transactionDate"
                type="date"
                class="w-100 date-picker-size"
                size="large"
                format="MM/DD/YYYY"
              />
            </div>
            <div class="col-md-6">
              <label
                for=""
                class="form-label label-text"
                style="font-size: 14px"
                >Add Description <span class="text-danger">*</span></label
              >
              <el-input
                v-model="memo"
                type="text"
                placeholder="Description"
                class="w-100"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 mt-4">
          <div class="col-md-12 h-100 border-radius-8 border-gray-400 py-3">
            <div class="row h-100">
              <div class="col-md-12 d-flex justify-content-start">
                <div class="col-md-4 px-0 mb-2">
                  <div class="fw-500 s-18 text-dak mb-n1">Debits</div>
                </div>
              </div>
              <div class="col-md-12">
                <div
                  class="row my-1 d-flex"
                  v-for="(transaction, indexe) in journalTransactions"
                  :key="indexe"
                >
                  <div
                    class="col-md-12"
                    v-if="transaction.category === 'inflow'"
                  >
                    <div class="row">
                      <div class="col-md-6">
                        <div class="col-md-12 px-0 label-text">
                          Select account Type
                        </div>
                        <el-dropdown trigger="click" class="w-100">
                          <span class="el-dropdown-link w-100">
                            <div
                              class="d-flex justify-content-between select-elem-con border-contribution w-100"
                              size="large"
                            >
                              <div>
                                {{
                                  !transaction.account
                                    ? "Select"
                                    : transaction.account
                                }}
                              </div>
                              <div>
                                <el-icon class="el-icon--right">
                                  <arrow-down />
                                </el-icon>
                              </div>
                            </div>
                          </span>
                          <template #dropdown>
                            <el-dropdown-menu>
                              <div
                                v-for="(
                                  accounts, index
                                ) in transactionalAccounts"
                                :key="index"
                              >
                                <div class="col-md-12 px-2">
                                  <div
                                    v-if="accounts.length > 0"
                                    class="py-2 px-2 s-14 font-weight-700 border-bottom"
                                  >
                                    {{ accountTypes[index] }}
                                  </div>

                                  <el-dropdown-item
                                    v-for="(account, indx) in accounts"
                                    :key="indx"
                                    @click="selectAccount(1, indexe, account)"
                                    class="c-pointer py-2"
                                  >
                                    {{ account.text }}
                                  </el-dropdown-item>
                                </div>
                              </div>
                            </el-dropdown-menu>
                          </template>
                        </el-dropdown>
                      </div>
                      <div class="col-md-6 mb-2 adjust-screen">
                        <div class="label-text">Amount</div>
                        <el-input
                          type="text"
                          class="w-100"
                          v-model="transaction.amount"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12 d-flex justify-content-between">
                <div class="col-8 px-0">
                  <a
                    class="text-decoration-none d-flex align-items-center fw-500 primary--text c-pointer"
                    @click="addRecord('inflow')"
                  >
                    <el-icon :size="14" class="mt-2s"><Plus /></el-icon>
                    <span class="fw-500" style="font-size: 14px"
                      ><u>Add Debit</u></span
                    >
                  </a>
                </div>
                <div
                  class="col-4 d-flex justify-content-end px-0"
                  v-if="
                    journalTransactions.length && journalTransactions.length > 2
                  "
                >
                  <div class="col-4 text-center px-0">
                    <el-icon
                      class="text-danger c-pointer"
                      @click="deleteRecord('inflow')"
                    >
                      <Delete />
                    </el-icon>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-12 font-weight-bold s-16 text-right text-dak">
            {{
              isNaN(sumOfRecords(debitRecords))
                ? 0
                : Math.round(sumOfRecords(debitRecords)).toLocaleString()
            }}
          </div>
        </div>
        <div class="col-md-6 mt-4">
          <div class="col-md-12 h-100 border-radius-8 border-gray-400 py-3">
            <div class="row h-100">
              <div class="col-md-12 d-flex justify-content-start">
                <div class="col-md-4 px-0 mb-2">
                  <div class="fw-500 s-18 text-dak mb-n1">Credits</div>
                </div>
              </div>

              <div class="col-md-12">
                <div
                  class="row my-1 d-flex"
                  v-for="(transaction, indexe) in journalTransactions"
                  :key="indexe"
                >
                  <div
                    class="col-md-12"
                    v-if="transaction.category === 'outflow'"
                  >
                    <div class="row">
                      <div class="col-md-6">
                        <div class="col-md-12 px-0 label-text">
                          Select account Type
                        </div>
                        <el-dropdown trigger="click" class="w-100">
                          <span class="el-dropdown-link w-100">
                            <div
                              class="d-flex justify-content-between select-elem-con border-contribution w-100"
                              size="large"
                            >
                              <div>
                                {{
                                  !transaction.account
                                    ? "Select"
                                    : transaction.account
                                }}
                              </div>
                              <div>
                                <el-icon class="el-icon--right">
                                  <arrow-down />
                                </el-icon>
                              </div>
                            </div>
                          </span>
                          <template #dropdown>
                            <el-dropdown-menu>
                              <div
                                v-for="(
                                  accounts, index
                                ) in transactionalAccounts"
                                :key="index"
                              >
                                <div class="col-md-12 px-2">
                                  <div
                                    v-if="accounts.length > 0"
                                    class="py-2 px-2 s-14 font-weight-700 border-bottom"
                                  >
                                    {{ accountTypes[index] }}
                                  </div>

                                  <el-dropdown-item
                                    v-for="(account, indx) in accounts"
                                    :key="indx"
                                    @click="selectAccount(0, indexe, account)"
                                    class="c-pointer py-2"
                                  >
                                    {{ account.text }}
                                  </el-dropdown-item>
                                </div>
                              </div>
                            </el-dropdown-menu>
                          </template>
                        </el-dropdown>
                      </div>
                      <div class="col-md-6 mb-2 adjust-screen">
                        <div class="label-text">Amount</div>
                        <el-input
                          type="text"
                          class="w-100"
                          v-model="transaction.amount"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12 d-flex justify-content-between">
                <div class="col-8 px-0">
                  <a
                    class="text-decoration-none d-flex align-items-center fw-500 primary--text c-pointer"
                    @click="addRecord('outflow')"
                  >
                    <el-icon :size="14" class="mt-2s"><Plus /></el-icon>
                    <span class="fw-500" style="font-size: 14px"
                      ><u>Add Credit</u></span
                    >
                  </a>
                </div>
                <div
                  class="col-4 d-flex justify-content-end px-0"
                  v-if="
                    journalTransactions.length && journalTransactions.length > 2
                  "
                >
                  <div class="col-4 text-center px-0">
                    <el-icon
                      class="text-danger c-pointer"
                      @click="deleteRecord('outflow')"
                    >
                      <Delete />
                    </el-icon>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-12 font-weight-bold s-16 text-right text-dak">
            <span>
              {{
                isNaN(sumOfRecords(creditRecords))
                  ? 0
                  : Math.round(sumOfRecords(creditRecords)).toLocaleString()
              }}
            </span>
          </div>
        </div>
      </div>

      <div class="row mt-5" v-if="false">
        <div class="col-md-6">
          <div class="col-md-12 h-100 border-radius-8 border-gray-400 py-3">
            <div class="row">
              <div class="col-md-12 d-flex justify-content-start">
                <div class="col-md-4 px-0 mb-2">
                  <div class="fw-500 s-18 text-dak mb-n1">Debits</div>
                </div>
              </div>
              <div class="col-md-12">
                <div
                  class="row my-1 d-flex"
                  v-for="(transaction, indexe) in journalTransactions"
                  :key="indexe"
                >
                  <div
                    class="col-md-12"
                    v-if="transaction.category === 'inflow'"
                  >
                    <div class="row">
                      <div class="col-md-6">
                        <div class="col-md-12 px-0 label-text">
                          Select account Type
                        </div>
                        <el-dropdown trigger="click" class="w-100">
                          <span class="el-dropdown-link w-100">
                            <div
                              class="d-flex justify-content-between select-elem-con border-contribution w-100"
                              size="large"
                            >
                              <div>
                                {{
                                  !transaction.account
                                    ? "Select"
                                    : transaction.account
                                }}
                              </div>
                              <div>
                                <el-icon class="el-icon--right">
                                  <arrow-down />
                                </el-icon>
                              </div>
                            </div>
                          </span>
                          <template #dropdown>
                            <el-dropdown-menu>
                              <div
                                v-for="(
                                  accounts, index
                                ) in transactionalAccounts"
                                :key="index"
                              >
                                <div class="col-md-12 px-2">
                                  <div
                                    v-if="accounts.length > 0"
                                    class="py-2 px-2 s-14 font-weight-700 border-bottom"
                                  >
                                    {{ accountTypes[index] }}
                                  </div>

                                  <el-dropdown-item
                                    v-for="(account, indx) in accounts"
                                    :key="indx"
                                    @click="selectAccount(1, indexe, account)"
                                    class="c-pointer py-2"
                                  >
                                    {{ account.text }}
                                  </el-dropdown-item>
                                </div>
                              </div>
                            </el-dropdown-menu>
                          </template>
                        </el-dropdown>
                      </div>
                      <div class="col-md-6 mb-2 adjust-screen">
                        <div class="label-text">Amount</div>
                        <el-input
                          type="text"
                          class="w-100"
                          v-model="transaction.amount"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12 d-flex justify-content-between">
                <div class="col-8 px-0">
                  <a
                    class="text-decoration-none d-flex align-items-center fw-500 primary--text c-pointer"
                    @click="addRecord('inflow')"
                  >
                    <el-icon :size="14" class="mt-2s"><Plus /></el-icon>
                    <span class="fw-500" style="font-size: 14px"
                      ><u>Add Debit</u></span
                    >
                  </a>
                </div>
                <div
                  class="col-4 d-flex justify-content-end px-0"
                  v-if="
                    journalTransactions.length &&
                    journalTransactions[journalTransactions.length - 1].isNew
                  "
                >
                  <div class="col-4 text-center px-0">
                    <el-icon
                      class="text-danger c-pointer"
                      @click="deleteRecord('inflow')"
                    >
                      <Delete />
                    </el-icon>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-12 px-0 d-flex justify-content-end">
            <div
              class="col-sm-6 col-md-4 col-10 mt-2 text-center border-radius-8 p-2 bg-gray-600"
            >
              <div class="fw-500 col-md-12 px-0 s-24 number-box text-dak">
                {{ sumOfRecords(debitRecords) }}
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="col-md-12 h-100 border-radius-8 border-gray-400 py-3">
            <div class="row">
              <div class="col-md-12 d-flex justify-content-start">
                <div class="col-md-4 px-0 mb-2">
                  <div class="fw-500 s-18 text-dak mb-n1">Credits</div>
                </div>
              </div>

              <div class="col-md-12">
                <div
                  class="row my-1 d-flex"
                  v-for="(transaction, indexe) in journalTransactions"
                  :key="indexe"
                >
                  <div
                    class="col-md-12"
                    v-if="transaction.category === 'outflow'"
                  >
                    <div class="row">
                      <div class="col-md-6">
                        <div class="col-md-12 px-0 label-text">
                          Select account Type
                        </div>
                        <el-dropdown trigger="click" class="w-100">
                          <span class="el-dropdown-link w-100">
                            <div
                              class="d-flex justify-content-between select-elem-con border-contribution w-100"
                              size="large"
                            >
                              <div>
                                {{
                                  !transaction.account
                                    ? "Select"
                                    : transaction.account
                                }}
                              </div>
                              <div>
                                <el-icon class="el-icon--right">
                                  <arrow-down />
                                </el-icon>
                              </div>
                            </div>
                          </span>
                          <template #dropdown>
                            <el-dropdown-menu>
                              <div
                                v-for="(
                                  accounts, index
                                ) in transactionalAccounts"
                                :key="index"
                              >
                                <div class="col-md-12 px-2">
                                  <div
                                    v-if="accounts.length > 0"
                                    class="py-2 px-2 s-14 font-weight-700 border-bottom"
                                  >
                                    {{ accountTypes[index] }}
                                  </div>

                                  <el-dropdown-item
                                    v-for="(account, indx) in accounts"
                                    :key="indx"
                                    @click="selectAccount(0, indexe, account)"
                                    class="c-pointer py-2"
                                  >
                                    {{ account.text }}
                                  </el-dropdown-item>
                                </div>
                              </div>
                            </el-dropdown-menu>
                          </template>
                        </el-dropdown>
                      </div>
                      <div class="col-md-6 mb-2 adjust-screen">
                        <div class="label-text">Amount</div>
                        <el-input
                          type="text"
                          class="w-100"
                          v-model="transaction.amount"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12 d-flex justify-content-between">
                <div class="col-8 px-0">
                  <a
                    class="text-decoration-none d-flex align-items-center fw-500 primary--text c-pointer"
                    @click="addRecord('outflow')"
                  >
                    <el-icon :size="14" class="mt-2s"><Plus /></el-icon>
                    <span class="fw-500" style="font-size: 14px"
                      ><u>Add Credit</u></span
                    >
                  </a>
                </div>
                <div
                  class="col-4 d-flex justify-content-end px-0"
                  v-if="
                    journalTransactions.length &&
                    journalTransactions[journalTransactions.length - 1]
                  "
                >
                  <div class="col-4 text-center px-0">
                    <el-icon
                      class="text-danger c-pointer"
                      @click="deleteRecord('outflow')"
                    >
                      <Delete />
                    </el-icon>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-12 px-0 d-flex justify-content-end">
            <div
              class="col-sm-6 col-md-4 col-10 mt-2 text-center border-radius-8 p-2 bg-gray-600"
            >
              <div class="fw-500 col-md-12 px-0 s-24 number-box text-dak">
                {{ sumOfRecords(creditRecords) }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-md-12 mt-4 text-center" v-if="unbalanced">
          <span class="text-center text-danger fw-500"
            >Debit account amount must be equal to credit account amount
          </span>
        </div>
        <div class="col-md-12 mt-3">
          <div class="w-100 font-weight-bold s-14 text-dak">Notes</div>
          <el-input
            v-model="note"
            placeholder="Write a note here"
            type="textarea"
            :rows="3"
            class="w-100"
          />
        </div>

        <div class="col-md-12 d-flex justify-content-end mb-2 mt-5">
          <div class="text-center cpon mr-2">
            <el-button
              style="border: 1px solid #aca6a6 !important"
              class="border-0 d-flex medium justify-content-center"
              round
              size="large"
              @click="closeLedgerForm"
            >
              <span class="font-weight-600 s-16"> Cancel </span>
            </el-button>
          </div>
          <div class="text-center cpon">
            <el-button
              class="text-white border-0 medium d-flex justify-content-center"
              color="#0040FF"
              round
              size="large"
              :disabled="unbalanced || journalDate"
              @click="saveTransaction"
            >
              <span> Save </span>
            </el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";
import transactionals from "../../accounting/chartOfAccount/utilities/transactionals";
import { computed, watch, watchEffect } from "@vue/runtime-core";
import transaction_service from "../../../services/financials/transaction_service";
import dateFormatter from "../../../services/dates/dateformatter";
import deviceBreakpoint from "../../../mixins/deviceBreakpoint";
import { ElNotification } from "element-plus";
import BackRoute from "../../../components/backroute/BackRoute.vue";
import router from "../../../router";

export default {
  props: ["journalEntry", "gettingSelectedTrsn"],
  components: {
    BackRoute,
  },

  setup(props, { emit }) {
    const { mdAndUp, lgAndUp, xlAndUp, xsOnly } = deviceBreakpoint();
    const selectedAccountType = ref({});
    const journalEntry = ref({});
    const iSoStringFormat = ref("");
    // const journalDate = ref("");
    const journalDate = ref(journalEntry.value.date);
    // const primarycolor = inject('primarycolor')
    const transactionalAccounts = ref([]);
    const accountTypes = [
      "assets",
      "liability",
      "equity",
      "income",
      "expense",
      "fund",
    ];

    const getTransactionalAccounts = async () => {
      try {
        const response = await transactionals.getGroupedAccounts2();
        // const response = await transactionals.getGroupedAccounts();

        transactionalAccounts.value = response;
      } catch (error) {
        console.log(error);
      }
    };
    getTransactionalAccounts();
    const getOpeningBalanceTransac = async () => {
      try {
        const response =
          await transaction_service.getOpeningBalanceTransactions();
        journalEntry.value = response.data || {};

        console.log(response, "opneing balance");
      } catch (error) {
        console.log(error);
      }
    };
    getOpeningBalanceTransac();

    const selectAccount = (type, index, account) => {
      if (type === 0) {
        journalTransactions.value[index].creditAccountID = account.id;
        journalTransactions.value[index].account = account.text;
      } else {
        journalTransactions.value[index].debitAccountID = account.id;
        journalTransactions.value[index].account = account.text;
      }
    };

    const journalTransactions = ref([]);
    const initializeJournalTransactions = () => {
      journalTransactions.value = [
        {
          category: "inflow",
          amount: 0.0,
          debitAccountID: "",
          creditAccountID: "",
        },
        {
          category: "outflow",
          amount: 0.0,
          debitAccountID: "",
          creditAccountID: "",
        },
      ];
    };

    initializeJournalTransactions();

    const sumOfRecords = (records) => {
      let sum = 0;
      for (let record of records) {
        sum += +record.amount;
      }
      return sum;
    };
    const deleteRecord = (category) => {
      const index = journalTransactions.value.findLastIndex(
        (i) => i.category === category
      );

      if (index !== -1) {
        journalTransactions.value.splice(index, 1);
      }
    };
    const addRecord = (category) => {
      journalTransactions.value.push({
        category: category,
        amount: 0.0,
        isNew: true, // Mark as new
      });
    };

    const debitRecords = computed(() => {
      if (!journalTransactions.value) return [];
      return journalTransactions.value.filter((i) => i.category === "inflow");
    });

    const creditRecords = computed(() => {
      if (!journalTransactions.value) return [];
      return journalTransactions.value.filter((i) => i.category === "outflow");
    });

    const totalAmount = computed(() => {
      if (!journalTransactions.value) return 0;
      const debits = journalTransactions.value.filter(
        (i) => i.category === "inflow"
      );

      return sumOfRecords(debits);
    });

    const unbalanced = computed(() => {
      const debitSum = sumOfRecords(debitRecords.value);
      const creditSum = sumOfRecords(creditRecords.value);
      return debitSum !== creditSum;
    });

    const memo = ref("");
    const note = ref("");
    const transactionDate = ref("");

    const saveTransaction = async () => {
      // Check if Date is selected
      if (!transactionDate.value || transactionDate.value === "") {
        ElNotification({
          type: "warning",
          message: "Please select a Date before saving.",
          duration: 3000,
        });
        return;
      }
      if (!memo.value || memo.value === "") {
        ElNotification({
          type: "warning",
          message: "Please add Description before saving.",
          duration: 3000,
        });
        return;
      }

      // 2. Validate Debit account selections
      const hasAllDebitAccounts = debitRecords.value.every(
        (record) => record.account && record.account !== ""
      );

      if (!hasAllDebitAccounts) {
        ElNotification({
          type: "warning",
          message: "Please select an Account Type for all Debit entries.",
          duration: 3000,
        });
        return;
      }

      // 3. Validate Credit account selections
      const hasAllCreditAccounts = creditRecords.value.every(
        (record) => record.account && record.account !== ""
      );

      if (!hasAllCreditAccounts) {
        ElNotification({
          type: "warning",
          message: "Please select an Account Type for all Credit entries.",
          duration: 3000,
        });
        return;
      }

      // Check if Debits and Credits match
      if (
        sumOfRecords(creditRecords.value) !==
          sumOfRecords(debitRecords.value) ||
        sumOfRecords(debitRecords.value) === 0
      ) {
        ElNotification({
          type: "error",
          message: "Debits and Credits must balance and cannot be zero.",
          duration: 3000,
        });
        return false;
      }

      const body = journalTransactions.value.map((i) => {
        return {
          memo: memo.value,
          note: note.value,
          date: iSoStringFormat.value,
          ...(i.debitAccountID ? { debitAccountID: i.debitAccountID } : {}),
          ...(i.creditAccountID ? { creditAccountID: i.creditAccountID } : {}),
          amount: i.amount,
        };
      });

      try {
        // const response = await transaction_service.saveJournalTransaction(body);
        const response = await transaction_service.saveOpeningTransaction(body);
        if (
          response.data.status === true &&
          response.status >= 200 &&
          response.status <= 300
        ) {
          ElNotification({
            type: "success",
            message: `The transaction was ${response.data.response}`,
            duration: 3000,
          });
          emit("entrysaved");
        } else if (
          response.data.status == false &&
          response.data.response.toLowerCase().includes("must equal")
        ) {
          ElNotification({
            type: "error",
            message: response.data.response,
            duration: 3000,
          });
        } else {
          ElNotification({
            type: "error",
            message: "Transaction failed, please try again",
            duration: 3000,
          });
        }
        // emit("close-ledger");
        router.push("/tenant/transactionlist");
      } catch (error) {
        ElNotification({
          type: "error",
          message: "Transaction failed, please try again",
          duration: 3000,
        });
        console.log(error);
      }
    };

    const closeLedgerForm = () => {
      emit("close-ledger");
    };

    watch(
      () => journalEntry.value,
      () => {
        if (journalEntry.value && journalEntry.value.date) {
          memo.value = journalEntry.value.memo;
          note.value = journalEntry.value.note;
          transactionDate.value = journalEntry.value.date;
          journalTransactions.value = [
            // Map debit split accounts
            ...journalEntry.value.debitSplitAccounts.map((i) => ({
              ...i,
              category: "inflow",
              account: i.account?.name || "",
              debitAccountID: i.accountID || i.account?.id || "",
              creditAccountID: "", // No credit for debit entry
            })),
            // Map credit split accounts
            ...journalEntry.value.creditSplitAccounts.map((i) => ({
              ...i,
              category: "outflow",
              account: i.account?.name || "",
              creditAccountID: i.accountID || i.account?.id || "",
              debitAccountID: "", // No debit for credit entry
            })),
          ];
        } else {
          initializeJournalTransactions();
        }
      }
    );

    watchEffect(() => {
      if (transactionDate.value) {
        iSoStringFormat.value = dateFormatter.getISOStringGMT(
          transactionDate.value
        );
      }
    });

    return {
      // primarycolor,
      journalEntry,
      deleteRecord,
      mdAndUp,
      lgAndUp,
      xlAndUp,
      xsOnly,
      accountTypes,
      journalDate,
      iSoStringFormat,
      selectedAccountType,
      selectAccount,
      transactionalAccounts,
      journalTransactions,
      addRecord,
      creditRecords,
      debitRecords,
      totalAmount,
      sumOfRecords,
      saveTransaction,
      unbalanced,
      memo,
      note,
      transactionDate,
      closeLedgerForm,
    };
  },
};
</script>

<style scoped>
/* Remove hover on the entire dropdown group */
.dropdown-group {
  padding: 6px 10px;
}
.custom-dropdown {
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  background-color: white;
  min-width: 250px;
}
.select-elem-con {
  padding: 10px 10px !important;
  justify-content: space-between;
  background: rgb(253, 253, 253);
  border: 1px solid #787878 !important;
  height: 44px !important;
  align-items: center;
}

/* Custom hover for individual items */
.hover-effect {
  padding: 6px 10px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.hover-effect:hover {
  background-color: #f0f0f0;
  border-radius: 4px;
}

/* Optional: Style group headers like Liability, Equity, etc. */
.dropdown-group h6 {
  color: #555;
  font-weight: 600;
  font-size: 0.9rem;
  padding: 4px 10px;
  margin-bottom: 2px;
}
.number-box {
  white-space: normal; /* Allows wrapping */
  overflow-wrap: break-word; /* Break long words/numbers */
  word-break: break-word; /* Ensures breaking even for long continuous numbers */
  display: block;
  max-width: 100%;
}
.parent-desc.first {
  color: #8898aa;
  font-size: 20px;
  font-weight: 700;
  color: #000000;
}
.label-text {
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  margin-bottom: 1px;
  color: #000000;
}
.select-elem-con {
  padding: 10px 10px;
  justify-content: space-between;
  background: rgb(253, 253, 253);
  border: 1px solid #a5a5a5 !important;
}
.form-control {
  height: 44px !important;
}

.bordered-bottom {
  border-bottom: 1px solid#00204412 !important;
}
/* .border-contribution {
  border: 1.6px solid rgb(255, 255, 255);
  border-radius: 4px;
  padding: 11px 7px;
  background-color: white;
} */

.bordered-top {
  border-top: 1px solid#00204412 !important;
}

.bordered {
  border: 1px solid#00204412 !important;
}

.greyish-color {
  color: #47525d;
}

.desc-area {
  border: 1px solid #00204412;
  background: white;
  margin-bottom: 10px;
}

.textarea {
  outline: transparent;
}

.textarea::placeholder {
  font-size: 18px;
}

.link-color {
  color: #343a40;
}
.hover-effect:hover {
  background-color: #f5f5f5;
  cursor: pointer;
}
@media screen and (max-width: 767px) {
  .adjust-screen {
    margin-top: 15px !important;
  }
}
</style>
